import { render, staticRenderFns } from "./addMember.vue?vue&type=template&id=2256cf8b&scoped=true"
import script from "./addMember.vue?vue&type=script&lang=js"
export * from "./addMember.vue?vue&type=script&lang=js"
import style0 from "./addMember.vue?vue&type=style&index=0&id=2256cf8b&prod&scoped=true&lang=scss"
import style1 from "./addMember.vue?vue&type=style&index=1&id=2256cf8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256cf8b",
  null
  
)

export default component.exports